import { fetcher } from '@services/requestV2'

export class TestAPI {
  static createTopicAttempt(
    quiz_id: string,
    question_topic_id: string,
    class_user_id?: string,
    story_topic_id?: string | string[] | undefined,
  ) {
    return fetcher(`quiz/case-study/topic-attempt`, {
      method: 'POST',
      data: {
        quiz_id,
        question_topic_id,
        class_user_id,
        story_topic_id,
      },
    })
  }

  static getQuestionAnswer(id: string) {
    return fetcher(`question/results`, {
      params: {
        question_ids: id,
      },
    })
  }

  static getResource(id: string) {
    return fetcher(`resource/${id}`)
  }
}
